import React, { useState, useMemo } from "react";

function InputSelectWithIcon({
  options = [],
  selected,
  onSelect,
  label = "",
  required = false,
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);

  const selectData = useMemo(
    () => options.find((item) => item.id == selected),
    [options, selected]
  );

  return (
    <div className={`control-group`}>
      <div className="tTitle">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </div>
      <div
        className="custom-select"
        tabIndex={0}
        onBlur={() => setDropdownOpen(false)}
        style={{
          position: "relative",
          width: "100%",
        }}
      >
        <div
          className="selected-option"
          onClick={() => setDropdownOpen((open) => !open)}
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #e5e5e5",
            borderRadius: 24,
            padding: "8px 16px",
            height: "36px",
            cursor: "pointer",
            background: "#fff",
          }}
        >
          {selectData && (
            <img
              src={selectData.logo}
              alt={selectData.name}
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                marginRight: 12,
                objectFit: "contain",
                background: "#fff",
                border: "1px solid #eee",
              }}
            />
          )}
          <span style={{ flex: 1 }}>
            {selectData ? selectData.name : <span style={{ color: '#aaa' }}>เลือกร้านค้า</span>}
          </span>
          <svg width="20" height="20" style={{ marginLeft: 8 }}>
            <path d="M5 8l5 5 5-5" stroke="#aaa" strokeWidth="2" fill="none" />
          </svg>
        </div>
        <div style={{marginTop: '4px'}}>
          {dropdownOpen && (
            <div style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: "100%",
              background: "#fff",
              border: "1px solid #e5e5e5",
              borderRadius: 12,
              margin: 0,
              padding: 0,
              zIndex: 10,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden", // สำคัญ!
            }}>
              <ul
                className="dropdown-list"
                style={{
                  height: "200px",
                  overflowY: "auto",
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                  /* ซ่อน scrollbar */
                  scrollbarWidth: "none",        // Firefox
                  msOverflowStyle: "none",       // IE/Edge
                }}
              >
                {options.map((option) => (
                  <li
                    key={option.id}
                    onClick={() => {
                      onSelect(option.id);
                      setDropdownOpen(false);
                    }}
                    onMouseEnter={() => setHoveredOption(option.id)}
                    onMouseLeave={() => setHoveredOption(null)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 16px",
                      cursor: "pointer",
                      background:
                        (selected && selected === option.id) ||
                        hoveredOption === option.id
                          ? "#f5f5f5"
                          : "#fff",
                    }}
                  >
                    <img
                      src={option.logo}
                      alt={option.name}
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        marginRight: 12,
                        objectFit: "cover",
                        background: "#fff",
                        border: "1px solid #eee",
                      }}
                    />
                    <span>{option.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default InputSelectWithIcon;
